module.exports = __webpack_public_path__ + "static/media/Banners_selecionados_IIIMostra.b5815bc9.xlsx";